import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { IconComponent } from 'components/layout/icon/icon.component';
import { TranslatePipe } from 'pipes/translate.pipe';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';

@Component({
	selector: 'status-messages',
	templateUrl: './status-messages.component.html',
	styleUrls: ['./status-messages.component.scss'],
	imports: [IconComponent, NgClass, TranslatePipe]
})
export class StatusMessagesComponent {
	constructor(readonly notificationService: NotificationService, readonly pushService: PushService) { }

	get connectionState() { return this.pushService.connectionState.toLowerCase(); }

	removeMessage(message: { languageVariable: string }) {
		this.notificationService.statusMessages.splice(this.notificationService.statusMessages.indexOf(message), 1)
	}
}
